// Copyright (c) 2017 Deere & Company

import _ from 'lodash';

export const checkForDuplicateClaims = (existingAudit, newAudit) => {

    const existingUserSelectedClaims = existingAudit.claims.filter(claim => !claim.isSystemSelected);

    const claimsNotCommonInExistingAndNew = _.differenceBy(existingUserSelectedClaims, newAudit.claims, 'claimNumber');

    return claimsNotCommonInExistingAndNew.length ?
        newAudit.claims.concat(claimsNotCommonInExistingAndNew) :
        newAudit.claims;

};



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/services/check-for-duplicate-claims.js